module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input', {
    attrs: {
      "type": _vm.spec.inputType,
      "name": _vm._name,
      "min": _vm.spec.min,
      "max": _vm.spec.max,
      "maxlength": _vm.spec.maxlength,
      "placeholder": _vm.spec.placeholder,
      "readonly": _vm._readonly
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79b301c9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-input.vue
// module id = 526
// module chunks = 55